import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";

const STATUSES = ["all", "new", "contacted", "converted", "archived"];

const Leads = () => {
  const [leads, setLeads] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/leads", {
        params: filter === "all" ? {} : { status: filter },
      });
      setLeads(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  return (
    <div data-testid="leads-page">
      <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#9c95a8]">Inbox</p>
      <h1 className="font-display text-4xl font-bold tracking-tight mt-2">Leads</h1>
      <p className="text-[#bdb6c4] mt-2">Every postcard that's landed. Click one to read it, add notes, or convert to a client.</p>

      <div className="mt-8 flex flex-wrap gap-2">
        {STATUSES.map((s) => (
          <button
            key={s}
            onClick={() => setFilter(s)}
            data-testid={`filter-${s}`}
            className={`px-3 py-1.5 rounded-full text-xs font-mono uppercase tracking-[0.18em] border transition-colors ${
              filter === s
                ? "bg-[#f5c76e] text-[#0a0a14] border-[#f5c76e]"
                : "border-white/10 text-[#bdb6c4] hover:bg-white/[0.04]"
            }`}
          >
            {s}
          </button>
        ))}
      </div>

      <div className="mt-6 space-y-2" data-testid="leads-list">
        {loading ? (
          <p className="text-[#9c95a8] text-sm">Loading…</p>
        ) : leads.length === 0 ? (
          <p className="text-[#9c95a8] text-sm">No leads {filter !== "all" && `with status "${filter}"`}.</p>
        ) : (
          leads.map((l) => (
            <Link
              key={l.id}
              to={`/admin/leads/${l.id}`}
              className="block bg-[#13121f] border border-white/10 rounded-xl px-5 py-4 hover:border-[#f5c76e]/30 transition-colors"
            >
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <div className="flex items-baseline gap-3 flex-wrap">
                    <p className="font-medium text-[#f4ede1]">{l.name}</p>
                    <p className="text-sm text-[#9c95a8]">{l.email}</p>
                    {l.notes?.length > 0 && (
                      <span className="font-mono text-[10px] text-[#6b6677]">· {l.notes.length} note{l.notes.length !== 1 && "s"}</span>
                    )}
                  </div>
                  <p className="text-sm text-[#bdb6c4] mt-1 line-clamp-2">{l.idea}</p>
                  <p className="font-mono text-[10px] text-[#6b6677] mt-2">
                    {new Date(l.created_at).toLocaleString()}
                  </p>
                </div>
                <span className={`font-mono text-[10px] uppercase tracking-[0.22em] px-2 py-1 rounded border whitespace-nowrap ${
                  l.status === "new" ? "border-[#f5c76e]/40 text-[#f5c76e]" :
                  l.status === "converted" ? "border-emerald-400/40 text-emerald-400" :
                  l.status === "contacted" ? "border-blue-400/40 text-blue-300" :
                  "border-white/15 text-[#9c95a8]"
                }`}>{l.status}</span>
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default Leads;
